<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-collapse visible>
                    <p class="mb-2">
                        <label>
                            Por favor tener en cuenta que los informes generados solo estarán disponibles por 2 horas
                        </label>
                        <b-button class="float-right" variant="primary" @click="reloadInformes">
                            Actualizar consulta
                        </b-button>
                    </p>
                    <b-table
                        class="mt-3"
                        responsive
                        striped
                        bordered
                        thead-tr-class="table-active"
                        hover
                        empty-text="No hay informes para mostrar"
                        show-empty
                        :items="informes"
                        :fields="columnas">
                    <template v-slot:cell(descargable)="data">
                            <b-button
                                variant="primary"
                                v-if="data.item.descargable"
                                @click="obtenerInforme(data.item)"
                                >
                                <i class="fa fa-floppy-o"></i>
                            Descargar
                            </b-button>
                    </template>
                    <template v-slot:cell(estado_procesamiento)="data">
                        <span v-if="!data.item.errores && data.item.estado_procesamiento">
                            {{ data.item.estado_procesamiento }}
                        </span>
                        <span v-else>
                            TERMINADO CON ERRORES <br />
                            {{ data.item.errores }}
                        </span>
                    </template>
                    </b-table>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { getAcls } from "../../../plugins/acl";
import loader from "../../../containers/loader";

    export default {
        name: 'informesAgendados',
        props: ['informes'],
        data() {
            return {
                loading: false,
                columnas:[
                {key: 'descargable', label: '', sortable: true, tdClass: 'descargableButton'},
                {key: 'empresa', label: 'Empresa', sortable: true, tdClass: 'empresaInforme'},
                {key: 'fecha_solicitud', label: 'Fecha de solicitud', sortable: true, tdClass: 'fechaSolicitud'},
                {key: 'fecha_generacion', label: 'Fecha de generación', sortable: true, tdClass: 'fechaGeneracion'},
                {key: 'estado_procesamiento', label: 'Estado de generación', sortable: true, tdClass: 'estadoGeneracion'}
            ],
            }
        },
        components: {
            loader
        },
        methods: {
          ...mapActions("background_processes", ['downloadReport']),
            async reloadInformes() {
                this.load(true);
                await this.listarInformesAgendados();
                this.load(false);
            },
            async obtenerInforme(item) {
              await this.downloadReport({id: item.id, json: {ruta_archivo: item.external_info.ruta_archivo}});
            },
            async DescargarArchivo(informe) {
                window.open(process.env.VUE_APP_API_URL + informe);
            },
            ...mapActions("registrosAccesos", [
                'descargarInforme',
                'listarInformesAgendados'
            ]),
            ...mapMutations("dashboard", ["load"])
        },
        computed: {
            ...mapState('registrosAccesos', [
                'informe',
                'error'
            ])
        }
    }
</script>
<style scoped>
.descargableButton {
    width: 70px !important;
    max-width: 100px !important;
    min-width: 70px !important;
}
.fechaSolicitud {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
.fechaGeneracion {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
.estadoGeneracion {
    width: 140px !important;
    max-width: 140px !important;
    min-width: 140px !important;
}
.empresaInforme {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
</style>